import React, { useState, useEffect } from "react";
// import PersonAdd from "@mui/icons-material/PersonAdd";
// import Settings from "@mui/icons-material/Settings";
// import Logout from "@mui/icons-material/Logout";
import { ModalContext } from "../BrowserAlert/modalContext";
import {
  Box,
  Avatar,
  Menu,
  MenuItem,
  //   ListItemIcon,
  Divider,
  IconButton,
  Typography,
  Tooltip,
  ListItemText,
  Collapse,
  List,
  ThemeProvider,
  lightTheme,
} from "@common-ui/ui";
import { useSelector } from "react-redux";
import { Auth } from "aws-amplify";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { SwitchOrganization } from "./SwitchOrganizationSecond";

export function AccountMenu(props) {
  let { handleModal } = React.useContext(ModalContext);
  const [user, setUser] = useState(null);
  const [isPlatformAdmin, setPlatformAdmin] = useState(
    window?.localStorage?.getItem("IS_PLATFORM_ADMIN")
      ? window?.localStorage?.getItem("IS_PLATFORM_ADMIN")
      : ""
  );

  const [openOrg, setOpenOrg] = React.useState(true);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const currentOrganization = useSelector(
    (state) => state.organization.currentOrganization
  );
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    getUser();
  }, []);

  async function getUser() {
    try {
      const user = await Auth.currentAuthenticatedUser();
      setUser(user);
      setPlatformAdmin(
        user?.attributes["custom:plat_admin"]
          ? user?.attributes["custom:plat_admin"]
          : ""
      );
    } catch (error) {
      console.log(error);
    }
  }
  return (
    <ThemeProvider theme={lightTheme}>
      <React.Fragment>
        <Box
          sx={{ display: "flex", alignItems: "center", textAlign: "center" }}
        >
          {props.children}
          <Tooltip title="Account settings">
            <IconButton
              onClick={handleClick}
              size="small"
              sx={{ ml: 2 }}
              aria-controls={open ? "account-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
            >
              <Avatar
                sx={{ width: 31, height: 31, border: " 1px solid #FFFFFF" }}
                src={`https://avatars.dicebear.com/v2/initials/${user?.username?.toLowerCase()}.svg?chars=1`}
              />
            </IconButton>
          </Tooltip>
        </Box>
        <Menu
          anchorEl={anchorEl}
          id="account-menu"
          open={open}
          onClose={handleClose}
          onClick={handleClose}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              mt: 1.5,
              // bgcolor: "#333333",
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              // "&:before": {
              //   content: '""',
              //   display: "block",
              //   position: "absolute",
              //   top: 0,
              //   right: 14,
              //   width: 10,
              //   height: 10,
              //   bgcolor: "#333333",
              //   transform: "translateY(-50%) rotate(45deg)",
              //   zIndex: 0,
              // },
            },
          }}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        >
          <MenuItem onClick={() => props.history.push("/user-profile")}>
            <ListItemText
              primary={user?.username}
              secondary={
                <React.Fragment>
                  <Typography
                    sx={{ display: "inline" }}
                    component="span"
                    variant="body2"
                    color="text.secondary"
                  >
                    {currentOrganization?.screen_name ||
                      currentOrganization?.name ||
                      "N/A"}
                  </Typography>
                  {/* {" — Wish I could come, but I'm out of town this…"} */}
                </React.Fragment>
              }
            />
          </MenuItem>
          <Divider />
          {/* <MenuItem> */}
          <MenuItem
            onClick={(event) => {
              event.stopPropagation();
              setOpenOrg(!openOrg);
            }}
          >
            <ListItemText primary="Organizations" />
            {openOrg ? <ExpandLess /> : <ExpandMore />}
          </MenuItem>
          <Collapse in={openOrg} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <SwitchOrganization />
            </List>
          </Collapse>
          {/* </MenuItem> */}
          <MenuItem disabled>Subscriptions & Billing</MenuItem>
          <MenuItem disabled>Create Notifications</MenuItem>
          {isPlatformAdmin?.toString() === "true" ? (
            <MenuItem onClick={() => props.history.push("/toplevelorg")}>
              Create Root Org
            </MenuItem>
          ) : (
            ""
          )}

          <MenuItem
            onClick={() => props.history.push("/orgs/tree-view/overview")}
          >
            View Orgs
          </MenuItem>

          {isPlatformAdmin?.toString() === "true" ? (
            <MenuItem onClick={() => props.history.push("/role")}>
              Set Role
            </MenuItem>
          ) : (
            ""
          )}

          {/* <MenuItem onClick={() => props.history.push("/all-settings")}>
            All Settings
          </MenuItem> */}
          {/* <MenuItem>
          <Avatar /> Profile
        </MenuItem>
        <MenuItem>
          <Avatar /> My account
        </MenuItem> */}
          <Divider />
          {/* <MenuItem>
          <ListItemIcon>
            <PersonAdd fontSize="small" />
          </ListItemIcon>
          Add another account
        </MenuItem>
        <MenuItem>
          <ListItemIcon>
            <Settings fontSize="small" />
          </ListItemIcon>
          Settings
        </MenuItem> */}
          <MenuItem disabled>Contact Us</MenuItem>
          <MenuItem
            onClick={async () => {
              try {
                await Auth.signOut();
                window?.localStorage.clear();
                window.location.href = "/";
              } catch (error) {
                // alert(error);
                handleModal(error, "Error");
              }
            }}
          >
            {/* <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon> */}
            Logout
          </MenuItem>
        </Menu>
      </React.Fragment>
    </ThemeProvider>
  );
}
